import appConstants from "../../../../../appConstants";
import {NumericEditor}  from "../../../../dataGrid/cellEditors";

class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.Parameters,
      keyColumn: "parameterId",
      enableFilters: false,
      enableSorting: false,
      columns: [
          {
            headerName: "ID",
            field: "parameterId",
            hide: true,
            headerTooltip: "Parameter ID"
          },
          {
            headerName: "Parameter",
            field: "parameterName",
            headerTooltip: "Parameter Name",
            minWidth: appConstants.columnWidth.PARAMETER
          },
          {
            headerName: "Default Value",
            field: "defaultValue",
            headerTooltip: "Default Value",
            minWidth: appConstants.columnWidth.PARAM_DEFAULT
          },
          {
            headerName: "Custom Value",
            field: "scenarioValue",
            headerTooltip: "Custom Value",
            minWidth: appConstants.columnWidth.PARAM_CUSTOM,
            editable: true,
            cellEditorFramework: NumericEditor
          }
       ]
    }
  }
}

export default GridConfig;
